// extracted by mini-css-extract-plugin
export default {"container":"AlVFA","title":"OyY-J","titleThin":"L7RgV","titleAbsolute":"_9MOTu","text":"idpx2","skeleton-progress":"WJlpB"};